module.exports = __webpack_public_path__ + "img/btn_qq.0.1.0_202602051651.png";